const API_LINK = process.env.REACT_APP_API_LINK;
const FRONT_LINK = process.env.REACT_APP_FRONT_LINK;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

export { API_LINK, FRONT_LINK, ENVIRONMENT };
